import { IllinoisOperationCost } from '..'

export const OperationCost = {
  ...IllinoisOperationCost,
} as const
